export default __webpack_public_path__ + "static/media/blueCircleEarthLogo.12bb45ea.svg";